import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getInitPopUpData,
  getNoSlip,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnSearchBtn from "@shared/components/SnSearchBtn";
interface popupProps {
  selectedData?: any;
  modalRef?: any;
  Menuprops?: menuInfo;
}

const SN_PRD_WMO_REG_001_POP_03 = forwardRef(
  ({ selectedData, modalRef, Menuprops }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    //#endregion
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });
    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    //#endregion

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        gridRefs.current["grid1"].current.stopEditing();
        const checkedRows = gridRefs.current["grid1"].current.getCheckedRows();
        const hasNoRouteItem = checkedRows.some((row: any) => {
          return row.cd_rout == null || row.cd_rout === "";
        });

        if (hasNoRouteItem) {
          return {
            flag: false,
            message:
              "공정경로가 등록안된 품목은 작업지시를 생성할 수 없습니다.",
          };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        const ok = await onSave();
        if (ok) return "success";
        return { result: false };
      },
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getCheckedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_WMO_REG_001_POP_03",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
          });
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo, selectedData]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_prd_wmo_reg_001_pop_01_03",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0] || [],
          });

          gridRefs.current["grid1"].current.resetUpdate();
        } catch (error) {}
      };
      await fetchdatasource();
    };

    const onSave = async () => {
      gridRefs.current["grid1"].current.stopEditing();
      const checkedRows =
        gridRefs.current["grid1"].current.getCheckedRows() || [];
      const createEmptyChanges = () => ({
        modifiedRowcount: 0,
        insert: [],
        update: [],
        delete: [],
      });
      const routeRowsByCheckedRow: { checkedRow: any; routeRows: any[] }[] = [];
      const bomRowsByCheckedRow: { checkedRow: any; bomRows: any[] }[] = [];
      const routeWarehouseByCheckedRow = new Map<any, any>();

      const hasNoRouteItem = checkedRows.some((row: any) => {
        return row.cd_rout == null || row.cd_rout === "";
      });

      if (hasNoRouteItem) {
        return false;
      }

      try {
        for (const checkedRow of checkedRows) {
          const routeData: any = await fnGetDataSet({
            id: "sn_prd_wmo_reg_001_searchrout",
            params: {
              cd_firm: userInfo.cd_firm,
              cd_rout: checkedRow.cd_rout,
            },
          });
          const routeRows = routeData?.[0] || [];
          routeRowsByCheckedRow.push({ checkedRow, routeRows });
        }
      } catch (error) {
        return false;
      }

      const issuedNoWoByRow = new Map<any, string>();
      try {
        for (const checkedRow of checkedRows) {
          const noWo = await getNoSlip(
            Menuprops?.cd_module || "PRD",
            1,
            "WMO",
            checkedRow.dt_wo,
            Menuprops?.cd_menu
          );

          if (typeof noWo !== "string" || noWo === "") {
            return false;
          }

          issuedNoWoByRow.set(checkedRow, noWo);
        }
      } catch (error) {
        return false;
      }

      checkedRows.forEach((checkedRow: any) => {
        checkedRow.no_wo = issuedNoWoByRow.get(checkedRow);
      });

      try {
        for (const checkedRow of checkedRows) {
          const bomData: any = await fnGetDataSet({
            id: "sn_prd_wmo_reg_001_searchboml",
            params: {
              cd_firm: userInfo.cd_firm,
              cd_biz: userInfo.cd_biz,
              cd_item: checkedRow.cd_item,
              dt_start: checkedRow.dt_wo,
            },
          });
          const bomRows = bomData?.[0] || [];
          bomRowsByCheckedRow.push({ checkedRow, bomRows });

          const routeWarehouseRows = await getTablebySql({
            sql: "select coalesce(r.cd_wh_isu,'') as cd_wh_isu, coalesce(wh.nm_wh,'') as nm_wh from prd_rout r left outer join mas_wh wh on r.cd_firm = wh.cd_firm and r.cd_wh_isu = wh.cd_wh where r.cd_firm = :cd_firm and r.cd_rout = :cd_rout",
            cd_firm: userInfo.cd_firm,
            cd_rout: checkedRow.cd_rout,
          });
          routeWarehouseByCheckedRow.set(
            checkedRow,
            routeWarehouseRows?.[0] || {}
          );
        }
      } catch (error) {
        return false;
      }

      const prdWoprocInsert = routeRowsByCheckedRow.flatMap(
        ({ checkedRow, routeRows }) => {
          const noWo = issuedNoWoByRow.get(checkedRow);

          return routeRows.map((routeRow: any, index: number) => ({
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_wo: noWo,
            no_line: index + 1,
            cd_op: routeRow.cd_op,
            ...(index > 0 ? { cd_op_pre: routeRows[index - 1].cd_op } : {}),
            nm_op: routeRow.nm_op,
            qt_wo: checkedRow.qt_wo,
            yn_end: routeRow.yn_end,
            yn_work: routeRow.yn_work,
            yn_qc: routeRow.yn_qc,
            st_proc: "F",
            qt_work: 0,
            qt_qc: 0,
            yn_sct: "N",
          }));
        }
      );
      const prdWobillInsert = bomRowsByCheckedRow.flatMap(
        ({ checkedRow, bomRows }) => {
          const noWo = issuedNoWoByRow.get(checkedRow);
          const routeWarehouse = routeWarehouseByCheckedRow.get(checkedRow);

          return bomRows.map((bomRow: any, index: number) => ({
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_line: index + 1,
            no_wo: noWo,
            cd_matl: bomRow.cd_matl,
            nm_matl: bomRow.nm_matl,
            dc_item_spec_matl: bomRow.dc_item_spec_matl,
            dc_item_unit_matl: bomRow.dc_item_unit_matl,
            qt_unit: Number(bomRow.qt_need),
            qt_need: Number(bomRow.qt_need) * Number(checkedRow.qt_wo),
            dt_dlv: checkedRow.dt_wo,
            cd_op: bomRow.cd_op,
            nm_op: bomRow.nm_op,
            yn_bf: bomRow.yn_bf,
            yn_matl_check: bomRow.yn_matl_check,
            cd_rout: checkedRow.cd_rout,
            cd_wh: routeWarehouse?.cd_wh_isu || checkedRow.cd_wh,
            nm_wh: routeWarehouse?.nm_wh || checkedRow.nm_wh,
          }));
        }
      );
      const prdWoInsert = checkedRows.map((checkedRow: any) => ({
        ...checkedRow,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        cd_dept: userInfo.cd_dept,
      }));

      const prdWoChanges = {
        modifiedRowcount: prdWoInsert.length,
        insert: prdWoInsert,
        update: [],
        delete: [],
      };
      const prdWobillChanges = {
        ...createEmptyChanges(),
        modifiedRowcount: prdWobillInsert.length,
        insert: prdWobillInsert,
      };
      const prdWoprocChanges = {
        ...createEmptyChanges(),
        modifiedRowcount: prdWoprocInsert.length,
        insert: prdWoprocInsert,
      };

      const SaveData = {
        prd_wo: prdWoChanges,
        prd_wobill: prdWobillChanges,
        prd_woproc: prdWoprocChanges,
      };

      const result = await fnSave("SN_PRD_WMO_REG_001_SAVE_01", SaveData);
    };
    //#endregion
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );
    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "60vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{
                rowSelection: "single",
                ischeckboxSelection: true,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WMO_REG_001_POP_03;
